import PageBrand from '@components/common/PageBrand'
import React from 'react'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded'
import { useHistory } from 'react-router-dom'
import BackgroundAnimation from '../components/common/BackgroundAnimation'
import { GlassCard } from '@components/common/Glass'

export default function Terms(): JSX.Element {
  const history = useHistory()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <div>
      <BackgroundAnimation />
      <Container
        sx={{
          pb: 6,
          minHeight: '100vh',
          px: { xs: 1, sm: 3 },
          mt: { xs: 2, sm: 4 },
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
        maxWidth="md"
      >
        <PageBrand />
        <GlassCard
          sx={{
            width: '100%',
            textAlign: 'left',
            p: { xs: 2.5, sm: 3.5 },
            borderRadius: '32px',
            borderColor: 'rgba(255,255,255,0.7)',
            boxShadow: '0 3px 0 #e0eaf2, 0 8px 18px #1c3b5709',
          }}
        >
          <Box>
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
              <IconButton onClick={() => history.goBack()}>
                <ArrowBackIosNewRoundedIcon fontSize="small" sx={{ mr: 0.25 }} />
              </IconButton>
              <Box />
            </Box>
            <Typography variant={fullScreen ? 'h4' : 'h3'} fontWeight={600}>
              Terms of Service
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={1}>
              RankTrivia, a product of Team Automate (&quot;Company&quot;, &quot;we&quot;,
              &quot;us&quot;, &quot;our&quot;), provides the RankTrivia website and mobile app (the
              &quot;Service&quot;), a game focused on trivia, rankings, and user-created lists.
            </Typography>

            <Typography variant="body2" color="#444" mt={1}>
              By accessing or using the Service, you agree to these Terms. If you do not agree, do
              not use the Service.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Eligibility
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              The Service is intended for users who are at least 13 years old. If you are under 13,
              do not use the Service.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Accounts
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              You are responsible for your account and any activity under it. Keep your credentials
              secure. We may suspend or terminate accounts that violate these Terms.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              User Content
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              You may create lists, rankings, and other content. You retain ownership of your
              content, but you grant us a worldwide, royalty-free license to host, display, and
              distribute it within the Service.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Prohibited Use
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              Do not use the Service to post illegal, abusive, or infringing content; attempt to
              access other users&apos; accounts; scrape the Service; or interfere with gameplay or
              service stability.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Intellectual Property
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              The Service, including code, design, logos, and audio/visual assets, is owned by us or
              our licensors and is protected by intellectual property laws. You may not copy or use
              our content except as permitted by these Terms.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Termination
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              We may suspend or terminate your access if you violate these Terms or if we
              discontinue the Service. You may delete your account at any time in the app.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Disclaimer
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              The Service is provided &quot;as is&quot; and &quot;as available.&quot; We do not
              warrant that the Service will be uninterrupted, secure, or error-free.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Limitation of Liability
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              To the maximum extent permitted by law, we are not liable for indirect, incidental,
              special, consequential, or punitive damages arising from your use of the Service.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Changes to These Terms
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              We may update these Terms from time to time. Changes are effective when posted on this
              page.
            </Typography>

            <Typography variant="h6" fontWeight={600} mt={4}>
              Contact Us
            </Typography>
            <Typography variant="body2" color="#444" mt={1}>
              If you have questions, contact us at{' '}
              <a
                href="mailto:info@teamautomate.com"
                style={{
                  color: '#53d9f5',
                  fontWeight: 600,
                  textDecoration: 'none',
                }}
              >
                info@teamautomate.com
              </a>
              .
            </Typography>
          </Box>
        </GlassCard>
      </Container>
    </div>
  )
}
